import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { get } from '@eika-infrastruktur/request';

import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { CreditCard, VirtualCard } from '@generated-types';

import { decryptVirtualCardMessage } from './decryptVirtualCardMessage';

const getVirtualCreditCard = async (card: CreditCard) => {
    const digitalCard = await get<VirtualCard>(`${KREDITTBANKEN_BASE_URL}/credit-cards/virtual/${card.cardNumber}`);

    const { message } = digitalCard;
    const decipheredMessage = decryptVirtualCardMessage(card.cardNumber.replaceAll('*', 'x'), message);
    return { ...digitalCard, message: decipheredMessage };
};

export const useKbVirtualCreditCard = (
    card: CreditCard,
    options?: Omit<UseQueryOptions<VirtualCard | undefined>, 'queryKey' | 'queryFn'>,
) => {
    return useQuery<VirtualCard | undefined>({
        ...options,
        queryKey: ['virtualCard', card],
        queryFn: () => getVirtualCreditCard(card),
        retry: false,
    });
};
